module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"status":"Status","ongoing":"Pending","completed":"Completed","pending":"To do"},"fr":{"status":"Statut","ongoing":"En cours","completed":"Réalisées","pending":"A faire"},"de":{"status":"Status","ongoing":"Im Gange","completed":"Vollendet","pending":"Machen"}}')
  delete Component.options._Ctor
}
